// Include this script anywhere in your code, preferably <HEAD> so icons can be fetched faster.
import "external-svg-loader";
